import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import { createBrowserHistory } from "history";
import rootReducer from './_rootReducer.js'

export const history = createBrowserHistory()

// const initialState = {}

// spread operator doesn't work with npm modules, as they are compiled to ES5. Read a thread where they recommended writing modules in ES5 for the coming years.. but maybe implementing babel will work?

// non-ES6 spread syntax alternative:
// handleClick() {
//   this.setState(state => ({
//     words: state.words.concat(['marklar'])
//   }));
// }

// the store.js for polls+ had this below un-commented, is the routerMiddleware needed?

// const enhancers = []
// const middleware = [
//   thunk,
//   routerMiddleware(history)
// ]

// if (process.env.NODE_ENV === 'development') {
//   const devToolsExtension = window.devToolsExtension

//   if (typeof devToolsExtension === 'function') {
//     enhancers.push(devToolsExtension())
//   }
// }

// const composedEnhancers = compose(
//   applyMiddleware(...middleware),
//   ...enhancers
// )

const store = createStore(
  rootReducer,
  // initialState,
  applyMiddleware(thunk, routerMiddleware(history))
)

export default store



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/store.js
// module id = 71
// module chunks = 1